// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__tragedyDisplay_5fe29a', '__tragedyDisplay_Fallback_5fe29a'"},"className":"o9GQyF"};